import { Theme } from '@mui/material/styles';

export const avatarStyles = (theme: Theme) => ({
    width: theme.spacing(7),
    height: theme.spacing(7),
    fontSize: '25px',
    backgroundColor: theme.palette.primary.main,
    '@media (min-width: 600px)': {
      width: theme.spacing(14),
      height: theme.spacing(14),
      fontSize: '50px'
    }
  });
